<template lang="pug">
.container
  modal-visualizar-conflito(
    v-if="conflitoSelecionado",
    :conflito="conflitoSelecionado",
    @closeModal="conflitoSelecionado = null"
  )
  el-card.card-container(shadow="hover")
    filtro(
      @pesquisar="search",
      @limpar="handleLimpar",
      :configuracaoFiltro="{}",
      :showfiltrosInformacoes="false"
    )
  app-listagem(
    :has-refresh-button="true",
    :showButtonOrdemServico="false",
    :showButtonAssinatura="false",
    :has-expansivel="false",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    :pagina="filtro.pagina",
    :hasFiltroRapido="false",
    :hasActionButton="showBotaoCadastrar()",
    :typeActionButton="'primary'",
    :nameActionButton="'Cadastrar'",
    :sizeActionButton="'md'",
    :filtro="filtro"
    :infoPrazos="false"
    :headerLabel="'Listagem de processos com conflitos'"
    :showCsvButton="false"
    @atualizarFiltro="atualizarFiltro"
    @updateListagem="search",
    @changePage="changePage",
    @sort="sort",
    @executar="executar",
    @click="novoConflito"
  )
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import AppListagem from '@/components/AppListagem.vue'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import ModalVisualizarConflito from '@/screens/ouvidoria/components/ModalVisualizarConflito.vue'

export default {

  components: {
    AppListagem,
    Filtro,
    ModalVisualizarConflito
  },

  mixins: [AppNotificacao],

  data () {
    return {
      filtro: FILTRO_EMPTY(),
      items: [],
      totalElements: 0,
      conflitoSelecionado: null,
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'interessado.cpfCnpj', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'interessado.nomeRazaoSocial', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Situação', propriedade: 'statusFormatado', ordem: 4, acoes: [], exibir: () => true },
        { id: 4, titulo: 'Município', propriedade: 'municipio.nome', sortable: true, ordem: 3, acoes: [], exibir: () => true },
        { id: 5, titulo: 'Data Chegada', propriedade: 'dataCriacaoFormatada', ordem: 4, acoes: [] },
        { id: 6, titulo: 'Tipo de Processo', propriedade: 'tipoProcesso.nome', ordem: 5, acoes: [] },
        {
          id: 11, titulo: 'Ações', propriedade: 'tipo', ordem: 6, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Atualizar Processo', icone: 'fa-pencil-alt', codigo: 'ANALISAR_PROCESSO', ordem: 1, show: this.showAnalisarProcesso, showToltip: this.showToltip, textToltip: this.textToltip },
            { id: 1, nome: 'Validar Shape', icone: 'fa-pencil-alt', codigo: 'VALIDAR_SHAPE', ordem: 1, show: this.showValidarShape, showToltip: this.showToltip, textToltip: this.textToltip },
            { id: 2, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1 },
            { id: 4, nome: 'Arquivar Processo', icone: 'fa-file-alt', codigo: 'ARQUIVAR_PROCESSO', ordem: 1, show: this.showArquivar }
          ]
        }
      ]
    }
  },

  mounted () {
    this.search()
  },

  computed: {
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    })
  },

  methods: {
    ...mapActions({
      getConflitosByFiltro: 'conflito/getConflitosByFiltro',
      arquivarConflito: 'conflito/arquivarConflito'
    }),

    showValidarShape (dado) {
      return dado.status === 'AGUARDANDO_VALIDACAO_SHAPE' && ['GCG', 'CGIR', 'GCG_CGIR'].includes(this.usuario.perfilSelecionado.setor.codigo)
    },

    showBotaoCadastrar () {
      return !['GCG', 'CGIR', 'GCG_CGIR'].includes(this.usuario.perfilSelecionado.setor.codigo)
    },

    showAnalisarProcesso (dado) {
      return !['FINALIZADO', 'ARQUIVADO', 'AGUARDANDO_VALIDACAO_SHAPE', 'AGUARDANDO_ARQUIVADO'].includes(dado.status)
    },

    showArquivar (dado) {
      return !['FINALIZADO', 'ARQUIVADO', 'AGUARDANDO_VALIDACAO_SHAPE'].includes(dado.status) && !['GCG', 'CGIR', 'GCG_CGIR'].includes(this.usuario.perfilSelecionado.setor.codigo)
    },

    atualizarFiltro (novoFiltro) {
      this.filtro = novoFiltro
    },

    async sort (item) {
      this.filtro.ordem = item.ordem
      this.filtro.ordemDirecao = item.tipo
      this.search()
    },

    executar (config) {
      this[config.acao](config.item)
    },
    VALIDAR_SHAPE (dado) {
      this.$router.push({ name: 'conflito/validar', params: { id: dado.id } })
    },
    ANALISAR_PROCESSO (dado) {
      this.$router.push({ name: 'ouvidoria/conflito/editar', params: { id: dado.id } })
    },
    VISUALIZAR_PROCESSO (dado) {
      this.conflitoSelecionado = dado
    },
    ARQUIVAR_PROCESSO (dado) {
      this.confirmBox(
        this.$messages.ARQUIVAR_CONFLITO,
        this.$messages.TITULO_WARNING,
        () => {
          this.arquivarConflito(dado.id)
            .then(async () => {
              this.showNotificacao(
                this.$messages.TIPO_SUCCESS,
                this.$messages.TITULO_SUCCESS,
                this.$messages.CONFLITO_ARQUIVADO_COM_SUCESSO
              )
              this.search()
            })
        },
        () => {}
      )
    },
    search (filtroParametro) {
      if (filtroParametro) {
        this.filtro = filtroParametro
      }
      this.getConflitosByFiltro(this.filtro)
        .then(response => {
          this.items = response.content
          this.totalElements = response.totalElements
        })
    },

    novoConflito () {
      this.$router.push({ name: 'ouvidoria/conflito/novo' })
    },

    handleLimpar () {
      this.filtro.numeroProcesso = ''
      this.filtro.status = null
      this.filtro.campoSimples = ''
      this.filtro.cpfCnpjInteressado = ''
      this.filtro.nomeInteressado = ''
      this.filtro.areaImovelComunidade = ''
      this.filtro.tipos = []
      this.filtro.tiposProcesso = []
      this.filtro.municipios = []
      this.filtro.dataCriacao = null
      this.search()
    },

    changePage (newPage) {
      this.filtro.pagina = newPage - 1
      this.search(this.filtro)
    }
  }
}
</script>

<style lang="scss" scoped>

  .container {
    display: flex;
    flex-direction: column;
  }

  .full-width {
    width: 100%;
  }

  .card-container {
    margin-left: 20px;
    margin-right: 20px;
  }

  /deep/ .cell {
    color: #424242;
  }
</style>



// WEBPACK FOOTER //
// src/screens/ouvidoria/GestaoConflito.vue